<template>
  <section class="world-background">
    <cards-roulette
      :options="options"
      :type="'ebidta_amount_ranges'"
      :withImages="false"
      :numerated="false"
    />
  </section>
</template>

<script>
import EbidtaAmountRanges from '@/constants/ebidta_amount_ranges.js'
import CardsRoulette from '@/components/on-board/CardsRoulette.vue'
import enumeratesFormater from '@/mixins/enumeratesFormater.js'
import OnBoardStepMixin from '@/mixins/onBoardStepMixin.js'
import store from '@/store'

export default {
  components: { CardsRoulette },
  mixins: [enumeratesFormater, OnBoardStepMixin],
  beforeRouteEnter(to, from, next) {
    const phase2Data = store.getters['onBoard/neofintechData'].phase2
    const isNormalFlow = from.name == 'onBoard.neofintech.phase2.4'
    const isException =
      phase2Data.ebidtaSign.includes('FQES01') ||
      phase2Data.ebidtaSign.includes('FQES02')
    if (isNormalFlow && isException) {
      next(vm => {
        store.commit('onBoard/SET_NEOFINTECH_EBIDTA_AMOUNT_RANGES', ['EAR00'])
        vm.$router.push({ name: 'onBoard.neofintech.phase2.6' })
      })
    } else {
      next()
    }
  },
  data() {
    return {
      options: []
    }
  },
  mounted() {
    this.options = EbidtaAmountRanges
  }
}
</script>
